import { jsx as _jsx } from "react/jsx-runtime";
import { getCohesionSnippet } from '@redventures/cohesion-utils';
export function CohesionSnippet({ config, src, }) {
    return (_jsx("script", { dangerouslySetInnerHTML: {
            __html: getCohesionSnippet(config, { src }),
        } }));
}
